<a class="nav-link dropdown-toggle arrow-none mx-1" data-bs-toggle="dropdown" href="#" (click)="ChatClick()" role="button"
    aria-haspopup="false" aria-expanded="false">
    <img src="assets/icons/chat_bubble_outline_black_24dp.svg" alt="">
    <span *ngIf="chatNavBarService.ChatNumber != 0 "
        class="badge rounded-pill badge-notification bg-danger">{{chatNavBarService.ChatNumber}}</span>
</a>